module.exports = __webpack_public_path__ + "static/media/unknown.af827ef9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cities/unknown.jpg
// module id = 284
// module chunks = 0